import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Assets
import logo from '../../../assets/images/Icon.svg';

// MUI
import {
  Container,
  Paper,
  Button,
  TextField,
  Box,
  Typography,
} from '@mui/material';

// Toastify
import { showSuccessToast, showErrorToast } from '../../../utils/toastUtils';

// Skeleton
import { Skeleton } from '@mui/material';

// NProgress
import NProgress from '../../../utils/nprogress';
import LinearProgress from '@mui/material/LinearProgress';

const Login = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // شبیه‌سازی لودینگ
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  // مدیریت ورود
  const handleLogin = async () => {
    const loginInput = document.querySelector("[name='loginInput']")?.value || '';
    const password = document.querySelector("[name='password']")?.value || '';

    if (!loginInput || !password) {
      showErrorToast("⚠️ لطفا تمام فیلدها رو پر کنید");
      return;
    }

    try {
      const res = await fetch('/db/login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: loginInput, password }),
        credentials: 'include'
      });

      const text = await res.text();

      let result;
      try {
        result = JSON.parse(text);
      } catch (parseError) {
        console.error("JSON Parse Error:", text);
        showErrorToast("❌ اطلاعات ورود صحیح نمی باشد ");
        return;
      }

      if (result.status === 'success') {
        showSuccessToast(" " + result.message);
        setTimeout(() => navigate('/project'), 1000);
      } else {
        showErrorToast("❌ " + result.message);
      }
    } catch (err) {
      console.error("Network Error:", err);
      showErrorToast("🚫 خطایی در برقراری ارتباط رخ داد");
    }
  };

  // مدیریت تغییر به ثبت‌نام
  const goToRegister = () => {
    NProgress.start();
    navigate('/auth/register');
    setTimeout(() => NProgress.done(), 1500);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'var(--color-bg)',
        padding: 2,
      }}
    >

      {/* نوار پیشرفت بالای صفحه */}
      {loading && <LinearProgress sx={{ position: 'fixed', height:'6px' , top: 0, left: 0, right: 0, zIndex: 9999 }} />}

      <Container maxWidth="sm">
        <Paper elevation={3} className="login-card">
          <Box sx={{ p: 3, textAlign: 'center' }}>
            {/* لوگو */}
            <Box sx={{ mb: 3 }}>
              <img src={logo} alt="لوگو" style={{ width: 50, height: 50 }} />
            </Box>

            {/* Skeleton در حالت لودینگ */}
            {loading ? (
              <Box sx={{ mt: 2 }}>
                <Skeleton variant="rectangular" height={60} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" height={60} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" height={48} />
              </Box>
            ) : (
              <>
                <TextField name="loginInput" label="نام کاربری یا ایمیل" fullWidth margin="normal" />
                <TextField name="password" label="رمز عبور" type="password" fullWidth margin="normal" />
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{ mt: 2 }}
                  onClick={handleLogin}
                >
                  ورود
                </Button>
              </>
            )}

            {/* دکمه تعویض فرم */}
            <Box sx={{ mt: 2 }}>
              <Typography
                variant="body2"
                component="p"
                onClick={goToRegister}
                sx={{
                  color: 'var(--color-primary)',
                  cursor: 'pointer',
                }}
              >
                حساب کاربری ندارید؟ ثبت نام کنید
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Login;